import type { SubmissionStatus } from './types.ts';

// Human labels for a submission's review status. Single source of truth for
// every review-status label — the on-screen badges (via docDisplayStatusLabel /
// questionDisplayStatusLabel) and the questionnaire PDF export all resolve
// through here, so they can never drift apart.
export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  pending: 'Pending',
  approved: 'Compliant',
  rejected: 'Not Compliant',
  not_applicable: 'N/A',
};

export function submissionStatusLabel(status: SubmissionStatus): string {
  return SUBMISSION_STATUS_LABELS[status];
}

// A compliance document that was approved but whose expiry has since lapsed is
// no longer compliant. `effectiveDocStatus` folds that in as a *display-only*
// status: the stored review status stays 'approved' — the API's company-level
// rollup (reviewRollup.ts) performs the real downgrade. It surfaces as a red
// "Not Compliant" badge, resolving the visual contradiction of a green
// "Compliant" document shown right next to a red "Expired" date.
export type DocDisplayStatus = SubmissionStatus | 'expired';

export function effectiveDocStatus(
  status: SubmissionStatus,
  isExpired: boolean,
): DocDisplayStatus {
  return status === 'approved' && isExpired ? 'expired' : status;
}

export function docDisplayStatusLabel(status: DocDisplayStatus): string {
  return status === 'expired' ? 'Not Compliant' : SUBMISSION_STATUS_LABELS[status];
}
